import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createBrowserRouter, RouterProvider, ScrollRestoration } from 'react-router-dom';

import App from './App';
import './index.css';
import './i18n';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000, // 5 minutos
    },
  },
});

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Elemento root no encontrado');
}
// Conserva las rutas existentes y habilita el bloqueo nativo de borradores.
const router = createBrowserRouter([
  {
    path: '*',
    element: (
      <>
        <App />
        <ScrollRestoration />
      </>
    ),
  },
]);

createRoot(rootEl).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
